
// CodigoField

import React from 'react';

function CodigoField({ value, onChange, readOnly }) {
  const handleInputChange = (event) => {
    if (!readOnly) {
      const newValue = event.target.value;
      onChange(newValue);
    }
  };

  const handleInputClick = () => {
    if (readOnly) {
      window.alert('Código do Cliente não pode ser alterado.');
    }
  };

  return (
    <div style={{ marginBottom: '0px' }}>
      <input 
        type="text"
        placeholder="Dgt. Código"
        style={{ width: '100px', height: '30px' }}
        value={value}
        onChange={handleInputChange}
        onClick={handleInputClick}
        readOnly={readOnly}
      />
    </div>
  );
}

export default CodigoField;